import {LandingScreen} from '../../screens/LandingScreen';
import {OnboardingScreen} from '../../screens/OnboardingScreen';
import {LoginScreen} from '../../screens/LoginScreen';
import {NavigationGroup} from '../../common/types';
import {DashboardScreen} from '../../screens/DashboardScreen';
import {HomeScreen} from '../../screens/HomeScreen';
import {ReviewCartDetailScreen} from '../../screens/ReviewCartDetailScreen';
import {OrderDetailScreen} from '../../screens/OrderDetailScreen';
import {OrderDashboardScreen} from '../../screens/OrderDashboardScreen';
import {PaymentDashboardScreen} from '../../screens/PaymentDashboardScreen';
import {TermsAndConditionsScreen} from '../../screens/TermsAndConditionsScreen';
import {PrivacyPolicyScreen} from '../../screens/PrivacyPolicyScreen';

export const routes: Array<NavigationGroup> = [
    {
        title: 'Landing Screen',
        path: '',
        component: LandingScreen,
    },
    {
        title: 'Login Screen',
        path: 'login',
        component: LoginScreen,
    },
    {
        title: 'Home Screen',
        path: 'home',
        component: HomeScreen,
    },
    {
        title: 'Cart Review Screen',
        path: 'cart/review',
        component: ReviewCartDetailScreen,
    },
    {
        title: 'Dashboard Screen',
        path: 'dashboard-screen',
        component: DashboardScreen,
    },
    {
        title: 'Onboarding Screen',
        path: 'onboarding-screen',
        component: OnboardingScreen,
    },
    {
        title: 'Order Details Screen',
        path: 'order/details',
        component: OrderDetailScreen,
    },
    {
        title: 'Orders Screen',
        path: 'orders/dashboard',
        component: OrderDashboardScreen,
    },
    {
        title: 'Payments Screen',
        path: 'payments/dashboard',
        component: PaymentDashboardScreen,
    },
    {
        title: 'Terms and Conditions',
        path: 'terms-and-conditions',
        component: TermsAndConditionsScreen,
    },
    {
        title: 'Privacy Policy',
        path: 'privacy-policy',
        component: PrivacyPolicyScreen,
    },
];
